export const EMPTY_DISPLAY_VALUE = "—";

export const formatDisplayValue = (
  value: string | number | null | undefined,
) => {
  if (value === null || value === undefined || value === "") {
    return EMPTY_DISPLAY_VALUE;
  }

  return String(value);
};
